import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
const firebaseConfig = {
  apiKey: "AIzaSyASxz8DJ1fsbrg2wxiIVcUeCNmDVJGdDq4",
  authDomain: "ymca-3a3e1.firebaseapp.com",
  projectId: "ymca-3a3e1",
  storageBucket: "ymca-3a3e1.appspot.com",
  messagingSenderId: "1096957638412",
  appId: "1:1096957638412:web:f6c4738c6cd6c6c728fb29",
  measurementId: "G-F70XNN2C21",
};
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
export { db };
